import deepExtend from '@/tools/deepExtend'
import util from '@/tools/commonUtil'
const files = require.context('.', true, /\.js$/)
const configs = []

var baseConfig = {
  id: '',
  surveyMainId: 0,
  quoteQuId: '',
  answerType: '',
  quCode: '', // 实际显示的题号（可以自己编辑）
  quNum: '', // 旧题号，系统自动排序生成，不能编辑
  status: 'view',
  userPage: '',
  page: 1,
  quLogics: [],
  quBeforLogics: [],
  answerRules: [],
  visibility: '1',
  randType: '2',
  imgUrl: '',
  imgName: '',
  randOrder: '0',
  minAnswerNum: 0,
  maxAnswerNum: 999,
  optionRuleType: '',
  exclusiveItemsId: '', // 排他项
  mutualItemsId: '',
  udfOptionInd: false, // 自定义选项互斥标志
  toolbar: {
    edit: true,
    delete: true,
    copy: true,
    config: true
  },
  title: '',
  showInPage: false,
  optionList: [],
  descList: [],
  ifOpenGroup: false,
  originTitle: '', // 原始标题
  titleId: '', // 用于引用的标题ID
  quContentLogics: [], // 内容逻辑
  quBeforLogicsNew: {}, // 题前逻辑（题目显示逻辑）
  quLogicsNew: {}, // 答案逻辑
  currentLang: '', // 当前语言
  ignore: false, // logic是否忽略该题，默认不忽略
  /**
   * 题目是否显示
   * 题组是否显示 && 题目是否显示 && 题目显示逻辑
   */
  ifVisibility () {
    return this.groupVisibility && this.quVisibility && this.visibility
  },
  /**
   * 处理多语言转换
   */
  syncLang (langMap) {
    // 当前语言
    const _this = this

    // 问卷多语言获取后，会存入session.storage
    if (sessionStorage.getItem('survey-lang')) {
      _this.currentLang = sessionStorage.getItem('survey-lang')
    }

    // 题干（根据标题Id获取相应语言的题干）
    this.title = util.cvtLang(langMap, _this.currentLang, this.titleId, this.title)
    this.orgTitle = this.title || ''
    this.displayTitle = this.orgTitle

    // 题型
    this.displayElementDesc = util.cvtLang(langMap, _this.currentLang, this.elementType, this.elementDesc)

    // 占位符
    this.displayPlaceholder = util.cvtLang(langMap, _this.currentLang, _this.placeholderId(), this.placeholder)

    // 选项
    if (this.optionList && this.optionList.length > 0) {
      // 滑块题/矩阵滑块/NPS/满意度题
      if (['NpsBox', 'RateBox', 'RateGroupBox', 'SatisfactionBox'].includes(this.elementType)) {
        this.optionList.forEach(item => {
          item.optionTitle = util.cvtLang(langMap, _this.currentLang, item.id, item.originTitle)
          item.orgTitle = item.optionTitle || ''
          item.displayTitle = item.orgTitle
        })
      } else {
        this.optionList.forEach(item => {
          item.optionName = util.cvtLang(langMap, _this.currentLang, item.id, item.originTitle)
          item.orgTitle = item.optionName || ''
          item.displayTitle = item.orgTitle
        })
      }
    }

    // 子问题
    if (this.descList && this.descList.length > 0) {
      this.descList.forEach(item => {
        item.optionName = util.cvtLang(langMap, _this.currentLang, item.id, item.originTitle)
        item.orgTitle = item.optionName || ''
        item.displayTitle = item.orgTitle
      })
    }

    // 分组
    if (this.ifOpenGroup) {
      this.optionGroupList.forEach(item => {
        item.optionGroupName = util.cvtLang(langMap, _this.currentLang, _this.optionGroupId(item.id), item.originTitle)
        item.orgTitle = item.optionGroupName || ''
        item.displayTitle = item.orgTitle
      })
    }
  },
  /**
   * 分组(单选/多选)
   */
  optionGroupId (id) {
    return this.id + 'group' + id
  },
  /**
   * 占位符(开放题)
   */
  placeholderId () {
    return this.id + 'placeholder'
  },
  /**
   * 遍历所有问题，处理引用
   * 业务：处理"引用"的替换(引用了其他题目的内容/答案 or #[暂无]其他嵌入的数据#)
   * 范围：问题/子问题/选项中的引用
   * @param {*} questionList 问卷的所有问题列表
   * @param {*} userInfo 客户属性
   */
  syncQuoteTitle (questionList, userInfo, custQuote) {
    // **** 处理问题引用 ****
    for (let i = 0; i < questionList.length; i++) {
      // 获取该题目的引用
      if (!questionList[i].getQuotedMap) {
        continue
      }
      let quotedMap = questionList[i].getQuotedMap(questionList)
      // 处理题干中的引用
      if (this.quoteQuId && this.quoteQuId === questionList[i].id) {
        this.displayTitle = this.setQuoteItemTitle(this, quotedMap)
      }

      // 处理子问题中的引用
      if (this.descList && this.descList.length > 0) {
        const filterDescList = this.descList.filter(item => item.quoteQuId === questionList[i].id)
        
        for (let j = 0; j < filterDescList.length; j++) {
          filterDescList[j].displayTitle = this.setQuoteItemTitle(filterDescList[j], quotedMap)
        }
      }

      // 处理问题选项中的引用
      if (this.optionList && this.optionList.length > 0) {
        const filterOptionList = this.optionList.filter(item => item.quoteQuId === questionList[i].id)
       
        for (let j = 0; j < filterOptionList.length; j++) {
          filterOptionList[j].displayTitle = this.setQuoteItemTitle(filterOptionList[j], quotedMap)
        }
      }
    }

    // **** 处理客户属性引用 ****
    // TODO 为了处理数据多语言，临时增加此逻辑
    // 当前语言
    const _this = this
    // 问卷多语言获取后，会存入session.storage
    if (sessionStorage.getItem('survey-lang')) {
      _this.currentLang = sessionStorage.getItem('survey-lang')
    }

    // 题干
    this.displayTitle = util.handlePlace(this.displayTitle, custQuote, _this.currentLang)

    this.clearReplacement(this)

    // 子问题
    if (this.descList && this.descList.length > 0) {
      this.descList.forEach((item, index) => {
        item.displayTitle = util.handlePlace(item.displayTitle, custQuote, _this.currentLang)

        this.clearReplacement(item)
      })
    }

    // 选项
    if (this.optionList && this.optionList.length > 0) {
      this.optionList.forEach((item, index) => {
        item.displayTitle = util.handlePlace(item.displayTitle, custQuote, _this.currentLang)

        this.clearReplacement(item)
      })
    }
  },
  // TODO：若被引用的题目或选项被删除，则占位符不显示
  clearReplacement(item) {
    if (new RegExp('\\${(\\w+)://([^/}]+/)+(\\w+)}', 'g').test(item.displayTitle)) {
      item.displayTitle = util.quoteReplace(item.displayTitle, '')
    }
  },
  /**
   * 处理问题引用
   *
   * @param {*} currentItem
   * @param {*} quotedMap
   */
  setQuoteItemTitle (currentItem, quotedMap) {
    const answerType = currentItem.answerType || '1'

    if (answerType === '1') {
      return util.quoteReplace(currentItem.orgTitle, quotedMap['SelectedOptions'])
    } else {
      return util.quoteReplace(currentItem.orgTitle, quotedMap['UnselectedOptions'])
    }
  },
  // 处理嵌套引用类型
  eachQuoteType(quList, quoteQuId) {
    const quoteObj = quList.find(item => (item.id === quoteQuId))
    let optionObj
    if (quoteObj && quoteObj.value) {
      optionObj = quoteObj.optionList.find(item => (item.id === quoteObj.value))
    }
    if (optionObj && optionObj.quoteQuId) {
      return this.eachQuoteType(quList, optionObj.quoteQuId)
    } else {
      return optionObj
    }
  },
  /**
   * 获取引用内容，按类型Key-Value映射
   * TODO 拆分题目/选项等引用
   * @returns
   */
  getQuotedMap (questionList) {
    let quotedMap = {
      QuestionText: '',
      SelectedOptionList: [],
      SelectedOptions: '',
      UnselectedOptionList: [],
      UnselectedOptions: ''
    }

    const {title, value, itemName} = this
    quotedMap['QuestionText'] = title

    if (value && value.length) {
      let valueList = []
      if (!(value instanceof Array)) {
        valueList = value.split(',')
      } else {
        valueList = value
      }

      // 处理并累加每个选项的处理结果
      // itemName的可能值：optionList（用于动态获取问题配置，具体参见各问题组件的config.js）
      if (this[itemName] && this[itemName].length > 0) {
        for (let i=0; i<this[itemName].length; i++) {
          // TODO: fix多层引用时引用逻辑未生效
          let { id, displayTitle, otherValue, type, quoteQuId } = this[itemName][i]
          let refTitle = displayTitle
          let quoteObj = this.eachQuoteType(questionList, quoteQuId)
          if (quoteObj && quoteObj.type === 'other') {
            otherValue = quoteObj.otherValue
            type = quoteObj.type
          }
          if (type === 'other') {
            refTitle = otherValue
          }
          if (valueList.includes(id)) {
            quotedMap['SelectedOptionList'].push(refTitle)
          } else {
            if (type === 'other') continue
            quotedMap['UnselectedOptionList'].push(refTitle)
          }
        }
      }
      
      // 极联题、选择题只可引用已选中答案
      if (['CascadeBox', 'SelectBox'].includes(this.elementType)) {
        quotedMap['SelectedOptionList'].push(this.textValue + (this.otherAnswer ? `,${this.otherAnswer}` : ''))
      }
    }

    quotedMap['SelectedOptions'] = quotedMap['SelectedOptionList'].join(',')
    quotedMap['UnselectedOptions'] = quotedMap['UnselectedOptionList'].join(',')
    return quotedMap
  },
  /**
   * 处理内容逻辑
   * @param {*} questionList
   * @param {*} userInfo
   * @param {*} Logic
   */
  syncContentLogic (questionList, userInfo, Logic, custQuote) {
    // 默认标题ID
    this.title = this.originTitle
    this.titleId = this.id
    
    const quContentLogicsLength = this.quContentLogics.length
    if (this.quContentLogics && quContentLogicsLength > 0) {
      let index = 0
      for (let i = 0; i < quContentLogicsLength; i++) {
        // 验证符合的内容逻辑，如果有一条符合则返回
        if (this.quContentLogics[i].logics && util.ifLogicGroup.call(this, this.quContentLogics[i].logics, userInfo, questionList, Logic, custQuote)) {
          // 使用内容逻辑标题
          // this.title = contentLogic.title
          this.title = this.getContentQuoteTitle(questionList, this.quContentLogics[i])
          this.titleId = this.genLangLogicId(index)
          break
        }
        index++
      }
    }
  },
  /**
   * 获取内容逻引用Title
   * @param {*} questionList
   * @param {*} userInfo
   * @param {*} Logic
   */
  getContentQuoteTitle(questionList, contentLogic) {
    if (contentLogic.quoteQuId) {
      // 获取引用题的答案
      const currQu = questionList.find(qu => qu.id === contentLogic.quoteQuId)
      let title
      // 单选
      if (currQu && currQu.elementType === 'RadioBox') {
        const optionItem = currQu.optionList.find(item => item.id === currQu.value)
        if(optionItem){
          if (optionItem.type === 'other') {
            title = optionItem.otherValue
          } else {
            title = optionItem.optionName
          }
        }else{
          title = ''
        }
      }
      // 多选
      if (currQu && currQu.elementType === 'CheckBox') {
        const arr = []
        currQu.value.forEach(val => {
          const curr = currQu.optionList.find(item => item.id === val)
          if (curr) {
            if (curr.type === 'other') {
              curr.otherValue.trim() && arr.push(curr.otherValue)
            } else {
              arr.push(curr.optionName)
            }
          }
        })
        title = arr.join('，')
      }
      // 极联题、城市选择题
      if (currQu && (['CascadeBox', 'SelectBox'].includes(currQu.elementType))) {
        title = currQu.textValue + (currQu.otherAnswer ? `,${currQu.otherAnswer}` : '')
      }

      return util.quoteReplace(contentLogic.title, title)
    } else {
      return contentLogic.title
    }
  },
  /**
   * 生成内容逻辑ID
   * @param {*} configId
   * @param {*} index
   * @returns
   */
  genLangLogicId (index) {
    return this.id + 'logic' + index
  }
}

files.keys().forEach((key) => {
  if (key === './index.js' || key === './config.js' || key === './logic.js' || key === './answer.js' || key === './validate.js' ||
    key === './answerValidate.js') {
    return
  }
  if (key.indexOf('config') > -1) {
    var config = files(key).default
    configs.push(deepExtend({}, baseConfig, config))
  }
})

configs.length && configs.sort((a, b) => a.orderById - b.orderById)
export default configs



// WEBPACK FOOTER //
// ./src/components/editor/config.js